export function hasPerm(permissions, permission) {
  return permissions.some(item => item.codename === permission)
}

export function checkPermission(permission) {
  let userInfo = {}
  if (localStorage) {
    userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  }

  if(!permission) {
    return true
  }

  if(userInfo && userInfo.permissions) {
    let permissions = userInfo.permissions.map(item => item.codename)
    if(permissions.includes(permission)) {
      return true
    }
  }
  return false
}


export function isAuthenticated(router) {
  let token = sessionStorage.getItem("token")
  if(router.matched.some(record => record.meta.requireAuth === true) && !token) {
    return false
  } else {
    return true
  }
}

export function loginWithToken(router) {
  if(router.name === "login") {
    return !!sessionStorage.getItem("token")
  } else {
    return false
  }
}
